// Năm tài chính của Trường: bắt đầu 01/04, kết thúc 31/03 năm sau.
// Chốt 2026-08-28 — trước đó màn "KPI nghiên cứu" mặc định theo năm dương lịch
// (01/01 – 31/12).
//
// Đổi mốc sau này chỉ cần sửa 2 hằng số dưới đây: ngày kết thúc được TÍNH RA
// (lùi 1 ngày trước mốc bắt đầu của năm kế tiếp) chứ không hardcode, nên không
// sợ lệch đầu–cuối.
export const FISCAL_YEAR_START_MONTH = 4; // tháng 4
export const FISCAL_YEAR_START_DAY = 1;

const pad = (n) => String(n).padStart(2, "0");
const toISODate = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

// getFiscalYear — năm tài chính chứa `date`. Mốc 1/4 nên tháng 1–3 vẫn thuộc
// năm tài chính bắt đầu từ năm dương lịch TRƯỚC đó.
//   15/03/2026 → 2025    (năm tài chính 01/04/2025 – 31/03/2026)
//   28/08/2026 → 2026    (năm tài chính 01/04/2026 – 31/03/2027)
export const getFiscalYear = (date = new Date()) => {
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) return new Date().getFullYear();
  const month = d.getMonth() + 1;
  const day = d.getDate();
  const beforeStart =
    month < FISCAL_YEAR_START_MONTH ||
    (month === FISCAL_YEAR_START_MONTH && day < FISCAL_YEAR_START_DAY);
  return beforeStart ? d.getFullYear() - 1 : d.getFullYear();
};

// getFiscalYearRange — { startDate, endDate } dạng 'YYYY-MM-DD' để gắn thẳng
// vào <TextField type="date">. Dùng Date theo giờ địa phương (không parse chuỗi
// UTC) để không bị lệch 1 ngày do múi giờ.
export const getFiscalYearRange = (fiscalYear = getFiscalYear()) => {
  const start = new Date(fiscalYear, FISCAL_YEAR_START_MONTH - 1, FISCAL_YEAR_START_DAY);
  const end = new Date(fiscalYear + 1, FISCAL_YEAR_START_MONTH - 1, FISCAL_YEAR_START_DAY);
  end.setDate(end.getDate() - 1); // lùi 1 ngày trước mốc năm sau
  return { startDate: toISODate(start), endDate: toISODate(end) };
};

// Nhãn hiển thị, vd "2026 - 2027".
export const getFiscalYearLabel = (fiscalYear = getFiscalYear()) =>
  `${fiscalYear} - ${fiscalYear + 1}`;
